import { UserTransactionHistoryPojo } from './UserTransactionHistoryPojo';
import { E_DonationPojo } from './E_DonationPojo';

export class DummyDonationTransactionPojo{

     donation =  new E_DonationPojo();
	 transaction = new UserTransactionHistoryPojo();


}